import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import tasksReducer from "./slices/tasksSlice";
import commentsReducer from "./slices/commentsSlice";
import usersReducer from "./slices/usersSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        tasks: tasksReducer,
        comments: commentsReducer,
        users: usersReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ['persist/PERSIST'],
        }
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;